<svg xmlns="http://www.w3.org/2000/svg" width="31" height="26" viewBox="0 0 31 26">
  <g fill="none" fill-rule="evenodd">
    <path fill="#C6B0E9" d="M0 0h30.587a.4.4 0 0 1 .21.74L21.6 6.4l9.196 5.66a.4.4 0 0 1-.21.74H0V0z"/>
    <path fill="#713AC9" d="M0 0h3.2v25.6H0z"/>
  </g>
</svg>
